<template>
  <div class="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-6">
    <div class="flex flex-col">
      <ApiTokensCard class="h-[400px] flex-1" />
    </div>

    <div class="flex flex-col">
      <ApiConsumptionCard class="h-[400px] flex-1" />
    </div>

    <div class="flex flex-col lg:col-span-2">
      <ApiUsageCard class="flex-1" />
    </div>
  </div>
</template>
